import type React from 'react';
import { BarChart3, CreditCard, Plug, ShoppingCart } from 'lucide-react';

interface ConnectorPresentation {
  icon: React.ElementType;
  color: string;
  bgColor: string;
}

/**
 * Icon and colour for a connector, keyed by its id.
 *
 * The ONLY thing about a connector this dashboard is allowed to hardcode, because it is the only
 * part the backend has no opinion on. Everything else — that a connector exists, what it is called,
 * what it asks for, what it unlocks — arrives from `GET /api/connectors`, so a vendor added to a
 * capability pack shows up here on its own. An unknown id falls back to a generic plug rather than
 * breaking the card, which is what makes that possible.
 */
const presentations: Record<string, ConnectorPresentation> = {
  woocommerce: {
    icon: ShoppingCart,
    color: 'text-purple-600 dark:text-purple-400',
    bgColor: 'bg-purple-100 dark:bg-purple-900/30',
  },
  shopify: {
    icon: ShoppingCart,
    color: 'text-green-600 dark:text-green-400',
    bgColor: 'bg-green-100 dark:bg-green-900/30',
  },
  stripe: {
    icon: CreditCard,
    color: 'text-indigo-600 dark:text-indigo-400',
    bgColor: 'bg-indigo-100 dark:bg-indigo-900/30',
  },
  analytics: {
    icon: BarChart3,
    color: 'text-orange-600 dark:text-orange-400',
    bgColor: 'bg-orange-100 dark:bg-orange-900/30',
  },
};

const fallback: ConnectorPresentation = {
  icon: Plug,
  color: 'text-gray-600 dark:text-gray-400',
  bgColor: 'bg-gray-100 dark:bg-gray-800',
};

export function connectorPresentation(connectorId: string): ConnectorPresentation {
  return presentations[connectorId] ?? fallback;
}
